// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j0n4","left":"styles_left__1_1rV"};